import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, MarketDataFeedAndBundleModel, PlatformFrontendInterface, SesService} from '@spa/api';
import {AddFeedBundleForm} from 'appEntries/panel/forms';
import {AlertsService, CurrencyService} from 'appShared/services';
import {MarketDataFeedBundleFormErrorStatesEnum, MarketDataFeedsFormErrorStatesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedsAddMessages} from 'appAssets/messages';
import {CheckboxControl} from 'appShared/classes';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';
import {FEEDID_CHECKBOX_PREFIX} from 'appAssets/descriptors';

@Component({
    selector: 'app-market-data-add-feed-bundle',
    templateUrl: './market-data-add-feed-bundle.component.html',
    styleUrls: ['./market-data-add-feed-bundle.component.scss']
})
export class MarketDataAddFeedBundleComponent extends PanelBaseMarketDataFormDialogComponent<MarketDataAddFeedBundleComponent> {

    public totalProPrice = 0;
    public totalNonProPrice = 0;
    public totals: {currency: string, totalNonProPrice: number, totalProPrice: number}[] = [];
    @Input() public feeds: MarketDataFeedAndBundleModel[];
    @Input() public platformFrontends: PlatformFrontendInterface[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            feeds: MarketDataFeedAndBundleModel[],
            platformFrontends: PlatformFrontendInterface[]
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        protected currencyService: CurrencyService,
        public dialogRef: MatDialogRef<MarketDataAddFeedBundleComponent>,
    ) {
        super(dialogRef, alertsService);
        this.config = data.config;
        this.feeds = data.feeds;
        this.platformFrontends = data.platformFrontends;
    }

    initForm(): void {
        this.form = new AddFeedBundleForm(this.sesService, this.currencyService, this.feeds, this.platformFrontends);
        this.form.initForm();

        const formChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const selectedFeeds = [];
            for (const key of Object.keys(data)) {
                const feedId = data[key];
                if (key.startsWith(FEEDID_CHECKBOX_PREFIX) && feedId > 0) {
                    selectedFeeds.push(feedId);
                }
            }
 
            this.calculateTotals(selectedFeeds);
            (this.form as AddFeedBundleForm).preparePlatformFrontendData(selectedFeeds);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedFeeds.length === 0;
        });

        this.subscriptions.push(formChangeSubscription);
    }

    getPlaceholderData(placeholder: string, splitIndex: number): string {
        return placeholder.split('-')[splitIndex];
    }

    calculateTotals(checkedFeeds: number[]): void { 
        const currentFeeds = this.feeds.filter(d => checkedFeeds.includes(d.id));
        this.totals = [];
        if(currentFeeds && currentFeeds.length > 0){
            currentFeeds.forEach(feed => {
                let currencyFeed = this.totals.find(c => c.currency == feed.defaultCurrency); 
                if(!currencyFeed){
                    currencyFeed = {currency: feed.defaultCurrency as string, totalNonProPrice: feed.defaultForNonPro as number, totalProPrice: feed.defaultForPro as number};
                    this.totals.push(currencyFeed);
                    return;
                }
                currencyFeed.totalProPrice += feed.defaultForPro;
                currencyFeed.totalNonProPrice += feed.defaultForNonPro; 
            });
        }
    }

    getErrorMessageByApiError(error: ApiError): string {
        switch (error.status) {
            case MarketDataFeedsFormErrorStatesEnum.CreateMarketDataFeedFailed:
                return MarketDataFeedsAddMessages.MarketDataFeedBundleCreationFailed.message;
            case MarketDataFeedBundleFormErrorStatesEnum.CreateMarketDataFeedBundleFailedNoFeed:
                return MarketDataFeedsAddMessages.CreateMarketDataFeedBundleFailedNoFeed.message;
            default:
                return MarketDataFeedsAddMessages.UnknownError.message;
        }
    }

    getSuccessFormMessage(): string {
        return MarketDataFeedsAddMessages.MarketDataFeedBundleCreationSucceed.message;
    }
}
